/**
 * Filtro local del maestro de cobranza (Lista de clientes / honorarios).
 */

/** Filtra filas del maestro / contratos por nombre o RFC. */
export function filterRosterItemsByQuery(items, query) {
  const q = String(query || "").trim().toLowerCase();
  if (!q) return Array.isArray(items) ? items : [];
  const list = Array.isArray(items) ? items : [];
  return list.filter((r) => {
    const name = String(r?.client_name || "").toLowerCase();
    const rfc = String(r?.rfc || r?.client_rfc || "").toLowerCase();
    return name.includes(q) || rfc.includes(q);
  });
}
